"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const theme_1 = require("../../theme");
const list_component_1 = require("../list/list.component");
const divider_component_1 = require("../divider/divider.component");
const menuItem_component_1 = require("./menuItem.component");
const subMenu_component_1 = require("./subMenu.component");
const menu_service_1 = require("./menu.service");
/**
 * `Menu` renders vertical list of `MenuItems`.
 *
 * @extends React.Component
 *
 * @property {string} appearance - Determines the appearance of the component.
 * Can be `default` or `noDivider`.
 * Default is `default`.
 *
 * @property {MenuItemType[]} data - Determines menu items.
 *
 * @property {number} selectedIndex - The index of selected item.
 *
 * @property {(index: number, event?: GestureResponderEvent) => void} onSelect - Fires when
 * selected item is changed.
 *
 * @property {Omit<ListProps, 'renderItem'>} ...ListProps - Any props applied to List component, excluding `renderItem`.
 *
 * @overview-example MenuSimpleUsage
 *
 * @overview-example MenuWithSubMenu
 *
 * @overview-example MenuWithIcons
 *
 * @overview-example MenuDisabledOptions
 *
 * @overview-example MenuWithoutDivider
 *
 * @example MenuInlineStyling
 */
class MenuComponent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.service = new menu_service_1.MenuService();
        this.onSelect = (selectedIndex, event) => {
            if (this.props.onSelect) {
                this.props.onSelect(selectedIndex, event);
            }
        };
        this.isDividerAbsent = () => {
            const { appearance } = this.props;
            return appearance !== 'noDivider';
        };
        this.areThereSubItems = (item) => {
            return item.subItems && item.subItems.length !== 0;
        };
        this.getIsSelected = (item) => {
            const { selectedIndex } = this.props;
            return selectedIndex === item.menuIndex;
        };
        this.renderMenuItem = (info) => {
            const { selectedIndex } = this.props;
            const isSelected = this.getIsSelected(info.item);
            return this.areThereSubItems(info.item) ? (react_1.default.createElement(subMenu_component_1.SubMenu, { item: info.item, selectedIndex: selectedIndex, divider: this.renderDivider(), onSelect: this.onSelect })) : (react_1.default.createElement(menuItem_component_1.MenuItem, Object.assign({}, info.item, { selected: isSelected, onPress: this.onSelect })));
        };
        this.renderDivider = () => {
            return this.isDividerAbsent() && (react_1.default.createElement(divider_component_1.Divider, null));
        };
    }
    render() {
        const { appearance, data, ...restProps } = this.props;
        const items = this.service.setIndexes(data);
        return (react_1.default.createElement(list_component_1.List, Object.assign({ ItemSeparatorComponent: this.renderDivider, renderItem: this.renderMenuItem, data: items }, restProps)));
    }
}
MenuComponent.styledComponentName = 'Menu';
exports.Menu = theme_1.styled(MenuComponent);
//# sourceMappingURL=menu.component.js.map